import { History, InsertChart, Timer } from "@mui/icons-material";
import { GridLocaleText } from "@mui/x-data-grid";
import { ListElement } from "./types";
import { isDev, roles } from "../pages/costants";

export const lightColor: string = "#b5d4d9";
export const darkColor: string = "#1d1d1b";
export const greyColor: string = "#969696";

//COLORI RUOLI
export const colors = {
  admin: "#3A4A5A",
  installer: "#589cb4",
  customer: "#E76B60",
  company: "#ffc464",
  maintainer: "#6FA28D",
  respMaintainer: "#5D4862",
};

export const checkColor = (role: string) => {
  console.log("checkColor", role);
  switch (role) {
    case roles.superadmin:
      return greyColor;
    case roles.admin:
      return colors.admin;
    case roles.installer:
      return colors.installer;
    case roles.customer:
      return colors.customer;
    case roles.company:
      return colors.company;
    case roles.maintainer:
      return colors.maintainer;
    case roles.respMaintainer:
      return colors.respMaintainer;
    default:
      return greyColor;
  }
};

//TABLE TEXT
export const customLocaleText: (t: any) => Partial<GridLocaleText> = (
  t: any
) => ({
  columnMenuSortAsc: t("sortAsc"),
  columnMenuSortDesc: t("sortDesc"),
  columnMenuUnsort: t("unsort"),
  columnMenuFilter: t("filter"),
  columnMenuHideColumn: t("hideColumn"),
  columnMenuShowColumns: t("showColumns"),
  columnMenuManageColumns: t("manageColumns"),
  columnsPanelHideAllButton: t("hideAll"),
  columnsPanelShowAllButton: t("showAll"),
  columnsPanelTextFieldLabel: `${t("findColumn")}`,
  columnsPanelTextFieldPlaceholder: `${t("search")}`,
  filterPanelAddFilter: t("addFilter"),
  filterPanelInputLabel: `${t("search")}`,
  filterPanelInputPlaceholder: `${t("search")}`,
  filterPanelRemoveAll: t("removeAll"),
  filterPanelColumns: t("columns"),
  filterPanelOperator: t("operators"),
  filterOperatorIsEmpty: `${t("isEmpty")}`,
  filterOperatorContains: `${t("contains")}`,
  filterOperatorStartsWith: `${t("startsWith")}`,
  filterOperatorEndsWith: `${t("endsWith")}`,
  filterOperatorIsNotEmpty: `${t("isNotEmpty")}`,
  filterOperatorEquals: `${t("equals")}`,
  filterOperatorIsAnyOf: `${t("isAnyOf")}`,
});

//NAVBAR OPTIONS
export const homeOptions: (t: any) => ListElement[] = (t: any) => [
  {
    primaryText: t("dashboard"),
    onClick: () => (window.location.pathname = "/dashboard"),
    startIcon: <InsertChart sx={{ color: lightColor, fontSize: "40px" }} />,
  },
  {
    primaryText: t("dataHistory"),
    onClick: () => (window.location.pathname = "/dataHistory"),
    startIcon: <History sx={{ color: lightColor, fontSize: "40px" }} />,
  },
  {
    primaryText: t("alarmsHistory"),
    onClick: () => (window.location.pathname = "/alarms"),
    startIcon: <Timer sx={{ color: lightColor, fontSize: "40px" }} />,
  },
];

export const capitalizedString = (inputString: string) =>
  inputString
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

//VALIDATION
export function isValidIPv4(str: string) {
  return /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/g.test(
    str
  );
}

export function isValidSSID(str: string) {
  return /^[^!#;+\]/"\t][^+\]/"\t]{0,30}[^ +\]/"\t]$|^[^ !#;+\]/"\t]$[ \t]+$/g.test(
    str
  );
}

export function isValidWPA2(str: string) {
  return /^[\u0020-\u007e]{8,63}$/g.test(str);
}

// JSON
export const prepareNetJson = (
  customWifi: { IFCS: any[] },
  customEth: { IFCS: any[] },
  apn: string
) => {
  return {
    IFCS: [
      // { ...customEth.IFCS[0] },
      { ...customWifi.IFCS[0] },
      {
        ifc_name: "cellular",
        ifc_params: { apn: apn },
      },
      // {
      //   ifc_name: "wifi",
      //   ifc_params: {
      //     ssid: "Zerynth",
      //     pwd: "TOIZerynth2021",
      //   },
      // },
      // {
      //   ifc_name: "wifi",
      //   ifc_params: {
      //     ssid: "CompasUffici",
      //     pwd: "Compas.2014",
      //   },
      // },
    ],
  };
};

export const prepareParamsJson = (
  th1: number,
  th2: number,
  ch1_on: "NO" | "NC",
  ch2_on: "NO" | "NC",
  ch3_on: "NO" | "NC",
  speed: number,
  system_power_aggregation: string,
  system_power_triphase: boolean,
  system_power_value: number,
  doors_power_aggregation: string,
  doors_power_triphase: boolean,
  doors_power_value: number
) => {
  return {
    CA1: {
      sensor: "CH5",
      clamp_type: "05V",
      amperage: 150,
      w_thresh: 90000,
      v_eff: 230,
      offset: system_power_value,
      three_phase: system_power_triphase,
      rolling_mode: system_power_aggregation,
      buff_len: 1,
    },
    CA2: {
      sensor: "CH6",
      clamp_type: "05V",
      amperage: 150,
      w_thresh: 90000,
      v_eff: 230,
      offset: doors_power_value,
      three_phase: doors_power_triphase,
      rolling_mode: doors_power_aggregation,
      buff_len: 1,
    },
    c_manovra: {
      sensor: "CH1",
      digital_type: "res",
      init_value: -1,
      rolling_mode: "max",
      buff_len: 1,
      type: ch1_on,
    },
    c_open: {
      sensor: "CH2",
      digital_type: "res",
      init_value: -1,
      rolling_mode: "max",
      buff_len: 1,
      type: ch2_on,
    },
    c_close: {
      sensor: "CH3",
      digital_type: "res",
      init_value: -1,
      rolling_mode: "max",
      buff_len: 1,
      type: ch3_on,
    },
    th1: th1,
    th2: th2,
    speed: speed,
  };
};

export const prepareSensorsJson = {
  CH1: {
    set: {
      type: "resistive",
      exp: null,
      input_number: 1,
      PGA: 2,
      SPS: 0,
    },
    conversion: {
      type: "lookup_table",
      args: {
        v_min: -50,
        ref_table: [0, 1],
        delta: 5,
        offset: 0,
        out_of_range: 0,
      },
    },
  },
  CH2: {
    set: {
      type: "resistive",
      exp: null,
      input_number: 2,
      PGA: 2,
      SPS: 0,
    },
    conversion: {
      type: "lookup_table",
      args: {
        v_min: -50,
        ref_table: [0, 1],
        delta: 5,
        offset: 0,
        out_of_range: 0,
      },
    },
  },
  CH3: {
    set: {
      type: "resistive",
      exp: null,
      input_number: 3,
      PGA: 2,
      SPS: 0,
    },
    conversion: {
      type: "lookup_table",
      args: {
        v_min: -50,
        ref_table: [0, 1],
        delta: 5,
        offset: 0,
        out_of_range: 0,
      },
    },
  },
  CH4: {
    set: {
      type: "voltage",
      exp: null,
      input_number: 4,
      PGA: 2,
      SPS: 3300,
    },
    conversion: {
      type: "linear",
      args: {
        x_min: 0,
        x_max: 9.85,
        y_min: 0,
        y_max: 12,
        offset: 0,
        under_x: 0.0,
        over_x: 12.0,
      },
    },
  },
  CH5: {
    set: {
      type: "voltage",
      exp: null,
      input_number: 5,
      PGA: 2,
      SPS: 3300,
    },
    conversion: {
      type: "linear",
      args: {
        x_min: 0,
        x_max: 10,
        y_min: 0,
        y_max: 10,
        offset: 0,
        under_x: 0.0,
        over_x: 10.0,
      },
    },
  },
  CH6: {
    set: {
      type: "voltage",
      exp: null,
      input_number: 6,
      PGA: 2,
      SPS: 3300,
    },
    conversion: {
      type: "linear",
      args: {
        x_min: 0,
        x_max: 10,
        y_min: 0,
        y_max: 10,
        offset: 0,
        under_x: 0.0,
        over_x: 10.0,
      },
    },
  },
};

export const prepareConfigJson = {
  params: {
    wtd: 60000,
    acq_freq: 500,
    fast_freq: 0,
    pub_freq: 1000,
    agent_timeout: 1500,
    store_period: 60,
    info_period: 300,
    exc_period: 300,
    dn_chunk_size: 32768,
    dn_wtd: 120000,
    offline_thr: 20,
    resolve_thr: 5,
    tlog_rsize: 1600,
    tlog_bsize: 512,
    tlog_thr: 2,
  },
};

export const prepareNetTestJson = {
  IFCS: [
    {
      ifc_name: "wifi",
      ifc_params: {
        ssid: "Zerynth",
        pwd: "TOIZerynth2021",
      },
    },
  ],
};

export const dashboardUrl = (role: string, id: string) => {
  if (isDev) {
    return `https://grafana.baglini.app.localhost/d/P5/p5?orgId=1&refresh=5s&kiosk=tv&var-device_id=${id}`;
  } else {
    if (role === roles.superadmin) {
      return `https://grafana.app.baglini.zerynth.com/d/superadmin/superadmin?orgId=1&refresh=5s&kiosk=tv&var-device_id=${id}`;
    }
    if (role === roles.admin) {
      return `https://grafana.app.baglini.zerynth.com/d/admin/p5-admin?orgId=1&refresh=5s&kiosk=tv&var-device_id=${id}`;
    }
    if (role === roles.installer) {
      return `https://grafana.app.baglini.zerynth.com/d/qazxsw/p5-installatore?orgId=1&refresh=5s&kiosk=tv&var-device_id=${id}`;
    }
    if (role === roles.customer) {
      return `https://grafana.app.baglini.zerynth.com/d/cliente/p5-cliente?orgId=1&refresh=5s&kiosk=tv&var-device_id=${id}`;
    }
    if (role === roles.company) {
      return `https://grafana.app.baglini.zerynth.com/d/azienda/p5-azienda?orgId=1&refresh=5s&kiosk=tv&var-device_id=${id}`;
    }
    if (role === roles.maintainer) {
      return `https://grafana.app.baglini.zerynth.com/d/manutentore/p5-manutentore?orgId=1&refresh=5s&kiosk=tv&var-device_id=${id}`;
    }
    if (role === roles.respMaintainer) {
      return `https://grafana.app.baglini.zerynth.com/d/responsabile_manutenzione/p5-respman-azienda?orgId=1&refresh=5s&kiosk=tv&var-device_id=${id}`;
    }
  }
};
